<div class="mutuallyExclusiveButtonsGroup">
  <div class="mutuallyExclusiveButtons">
    <button
      class="button"
      mat-raised-button
      [color]="qType === QTYPE.MULTIPLECHOICE ? 'primary' : 'secondary'"
      (click)="updateType(QTYPE.MULTIPLECHOICE)"
    >
      {{ 'Multiple Choice' | uppercase }}
    </button>
    <button
      class="primary-muted-button button"
      [color]="qType === QTYPE.FREEANSWER ? 'primary' : 'secondary'"
      mat-raised-button
      (click)="updateType(QTYPE.FREEANSWER)"
    >
      {{ 'Free Response' | uppercase }}
    </button>
    <button
      class="button"
      mat-raised-button
      [color]="qType === QTYPE.BOOLEANCHOICE ? 'primary' : 'secondary'"
      (click)="updateType(QTYPE.BOOLEANCHOICE)"
    >
      {{ 'True and False' | uppercase }}
    </button>
  </div>
</div>
